import { AppColors } from '@/assets/colors';
import { pxToRem } from '@/util'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
type props={
    action:string,
    description:string
}
export default function AuthHead({action,description}:Partial<props>) {
    const {classes}=styles();
  return (
    <Box className={classes.container}>
    <Typography className={classes.hdTxt}>
   {action||' Lets sign in'}
    </Typography>
    <Typography className={classes.hdDetTxt}>
    {description||'Sign in with your Email'}
    </Typography>
 </Box>
  )
}


const styles=makeStyles()((theme)=>({
    container:{
        dipslay:'flex',
    flexDirection:'column',
    gap:theme.spacing(3),
    justifyItems:'center'
    },
    hdTxt:{
            fontFamily: "Playfair Display",
            fontWeight: 700,
            fontSize: pxToRem(38), 
        },
        hdDetTxt:{
            fontWeight: 400,
            fontSize: pxToRem(18),
            lineHeight:pxToRem(26),
            color:AppColors.text.second
        },
}))